import { useState, useEffect } from 'react';
import {
  isAuthenticated,
  signIn,
  signOut,
  getUser,
  handleCallback
} from './oidcClient';

export function useAuth() {
  console.log('[useAuth] Hook useAuth chamado');
  
  const [isAuthenticatedState, setIsAuthenticatedState] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    console.log('[useAuth] useEffect executado, chamando checkAuth...');
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      console.log('[useAuth] Verificando autenticação...');
      setIsLoading(true);
      
      // Timeout de 10 segundos para verificação de autenticação
      const authenticated = await Promise.race([
        isAuthenticated(),
        new Promise((resolve) => {
          setTimeout(() => {
            console.warn('[useAuth] Timeout na verificação de autenticação, assumindo não autenticado');
            resolve(false);
          }, 10000);
        })
      ]);
      
      console.log('[useAuth] Resultado da verificação:', authenticated);
      setIsAuthenticatedState(authenticated);
      
      if (authenticated) {
        try {
          const userData = await Promise.race([
            getUser(),
            new Promise((_, reject) => {
              setTimeout(() => reject(new Error('Timeout ao obter dados do usuário')), 5000);
            })
          ]);
          console.log('[useAuth] Dados do usuário:', {
            sub: userData?.profile?.sub,
            name: userData?.profile?.name
          });
          setUser(userData);
        } catch (userError) {
          console.warn('[useAuth] Erro ao obter dados do usuário:', userError);
          // Continuar mesmo se não conseguir obter dados do usuário
        }
      }
    } catch (error) {
      console.error('[useAuth] Erro ao verificar autenticação:', error);
      console.error('[useAuth] Stack:', error.stack);
      setIsAuthenticatedState(false);
    } finally {
      setIsLoading(false);
      console.log('[useAuth] Verificação concluída, isLoading:', false);
    }
  };

  const login = async () => {
    await signIn();
  };

  const logout = async () => {
    await signOut();
    setIsAuthenticatedState(false);
    setUser(null);
  };

  const handleAuthCallback = async () => {
    try {
      const userData = await handleCallback();
      setUser(userData);
      setIsAuthenticatedState(true);
      return userData;
    } catch (error) {
      console.error('Erro no callback de autenticação:', error);
      throw error;
    }
  };

  return {
    isAuthenticated: isAuthenticatedState,
    isLoading,
    user,
    login,
    logout,
    handleAuthCallback,
    refresh: checkAuth
  };
}

